import type {
  HeatmapCacheValue,
  HeatmapDataType,
  IHeatmapDataStoreState,
} from '../stores/heatmap-data';
import type { HeatmapWSMessageType } from '../types/websocket';

import { useWSBaseCachedQuery } from '~/modules/apps/websocket/useWSBaseCachedQuery';
import { HEATMAP_QUERY_KEYS } from './useWSFetchHeatmapData';
import { useHeatmapDataStore } from '../stores/heatmap-data';

export interface UseWSHeatmapBaseConfig<T> {
  dataType: HeatmapDataType;
  wsMessageKey: HeatmapWSMessageType;
  cacheSelector: (state: IHeatmapDataStoreState) => Record<string, HeatmapCacheValue<T>>;
  upsertSelector: (
    state: IHeatmapDataStoreState,
  ) => (key: string, value: HeatmapCacheValue<T>) => void;
  emptyData: T | undefined;
}

export const useWSHeatmapBase = <T>(config: UseWSHeatmapBaseConfig<T>) => {
  const { dataType, wsMessageKey, emptyData } = config;

  const cache = useHeatmapDataStore(config.cacheSelector);
  const upsertCache = useHeatmapDataStore(config.upsertSelector);
  const findCacheKeyByRequestId = useHeatmapDataStore((state) => state.findCacheKeyByRequestId);

  return useWSBaseCachedQuery<T>({
    wsMessageKey,
    queryKeyPrefix: HEATMAP_QUERY_KEYS[dataType],
    label: `heatmap ${dataType}`,
    cache,
    upsertCache,
    findCacheKeyByRequestId: (requestId) => findCacheKeyByRequestId(dataType, requestId),
    emptyData,
  });
};
